import React, { useState, useEffect } from "react";

// reactstrap components
import { Container, Row, Col } from "reactstrap";

// core components

function SectionDark2() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div id="our-vision" style={{
      background: 'linear-gradient(135deg, #7C3AED 0%, #EC4899 100%)',
      padding: '120px 0',
      position: 'relative',
      overflow: 'hidden',
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center'
    }}>
      {/* Animated Background Elements */}
      <div style={{
        position: 'absolute',
        top: '15%',
        right: '5%',
        width: '180px',
        height: '180px',
        background: 'radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)',
        borderRadius: '50%',
        animation: 'float 7s ease-in-out infinite 1s'
      }}></div>
      
      <div style={{
        position: 'absolute',
        bottom: '10%',
        left: '8%',
        width: '220px',
        height: '220px',
        background: 'radial-gradient(circle, rgba(79, 172, 254, 0.1) 0%, transparent 70%)',
        borderRadius: '50%',
        animation: 'float 9s ease-in-out infinite 3s'
      }}></div>

      {/* Floating Icons */}
      <div style={{
        position: 'absolute',
        top: '25%',
        left: '10%',
        animation: 'bounce 3s infinite 0.5s'
      }}>
        <i className="fa fa-lightbulb-o" style={{ 
          fontSize: '45px', 
          color: 'rgba(255,255,255,0.3)',
          animation: 'pulse 2s infinite'
        }} />
      </div>
      
      <div style={{
        position: 'absolute',
        bottom: '20%',
        right: '12%',
        animation: 'bounce 3s infinite 2s'
      }}>
        <i className="fa fa-star" style={{ 
          fontSize: '38px', 
          color: 'rgba(255,255,255,0.3)',
          animation: 'pulse 2s infinite 1.5s'
        }} />
      </div>

      <div style={{
        position: 'absolute',
        top: '50%',
        left: '3%',
        animation: 'bounce 3s infinite 1s'
      }}>
        <i className="fa fa-diamond" style={{ 
          fontSize: '32px', 
          color: 'rgba(255,255,255,0.3)',
          animation: 'pulse 2s infinite 0.8s'
        }} />
      </div>

      <Container style={{ position: 'relative', zIndex: 2 }}>
        <Row>
          <Col className="ml-auto mr-auto text-center" md="10">
            <div style={{
              background: 'rgba(255,255,255,0.1)',
              borderRadius: '30px',
              padding: '80px 60px',
              backdropFilter: 'blur(20px)',
              border: '1px solid rgba(255,255,255,0.2)',
              boxShadow: '0 30px 60px rgba(0,0,0,0.2)',
              position: 'relative',
              overflow: 'hidden',
              transform: isVisible ? 'translateY(0)' : 'translateY(50px)',
              opacity: isVisible ? 1 : 0,
              transition: 'all 1s ease-out 0.3s'
            }}>
              {/* Decorative Elements */}
              <div style={{
                position: 'absolute',
                top: '-60px',
                left: '-60px',
                width: '120px',
                height: '120px',
                background: 'linear-gradient(45deg, #ff6b6b, #feca57)',
                borderRadius: '50%',
                opacity: 0.2
              }}></div>
              
              <div style={{
                position: 'absolute',
                bottom: '-40px',
                right: '-40px',
                width: '80px',
                height: '80px',
                background: 'linear-gradient(45deg, #4facfe, #00f2fe)',
                borderRadius: '50%',
                opacity: 0.2
              }}></div>

              <div style={{ position: 'relative', zIndex: 2 }}>
                <h2 style={{
                  color: 'white',
                  fontSize: '4rem',
                  fontWeight: '800',
                  marginBottom: '40px',
                  textShadow: '0 4px 8px rgba(0,0,0,0.3)',
                  background: 'linear-gradient(45deg, #ff6b6b, #feca57, #4facfe)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text'
                }}>
                  🔮 Our Vision
                </h2>

                <div style={{
                  width: '120px',
                  height: '4px',
                  background: 'linear-gradient(45deg, #ff6b6b, #feca57)',
                  margin: '0 auto 50px',
                  borderRadius: '2px'
                }}></div>
                
                <div style={{
                  background: 'rgba(255,255,255,0.05)',
                  borderRadius: '20px',
                  padding: '40px',
                  border: '1px solid rgba(255,255,255,0.1)',
                  marginBottom: '30px'
                }}>
                  <p style={{
                    color: 'rgba(255,255,255,0.95)', 
                    fontSize: '1.4rem', 
                    fontWeight: '400',
                    lineHeight: '1.8',
                    margin: 0,
                    textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                  }}>
                    We strive to provide the <span style={{ color: '#feca57', fontWeight: '600' }}>best innovative technology today for a better tomorrow</span>. 
                    We are committed to <span style={{ color: '#ff6b6b', fontWeight: '600' }}>sustainable business</span>, excellence in quality and reliable services. 
                    We conduct our business with integrity to deliver optimal values to stakeholders.
                  </p>
                </div>

                <div style={{
                  background: 'rgba(255,255,255,0.05)',
                  borderRadius: '20px',
                  padding: '40px',
                  border: '1px solid rgba(255,255,255,0.1)',
                  marginBottom: '30px'
                }}>
                  <p style={{
                    color: 'rgba(255,255,255,0.95)', 
                    fontSize: '1.4rem', 
                    fontWeight: '400',
                    lineHeight: '1.8',
                    margin: 0,
                    textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                  }}>
                    We consider our experience as a growing component whereby we fully devote ourselves to 
                    bringing the <span style={{ color: '#ff6b6b', fontWeight: '600' }}>Marketing industry to a whole new level</span>. Our rich years of experience in the 
                    field have granted us a fully developed <span style={{ color: '#4facfe', fontWeight: '600' }}>"know-how" structure</span> that we build on to remain 
                    one of the biggest digital marketing Solutions Providers in the world.
                  </p>
                </div>

                <div style={{
                  background: 'rgba(255,255,255,0.05)',
                  borderRadius: '20px',
                  padding: '40px',
                  border: '1px solid rgba(255,255,255,0.1)',
                  marginBottom: '30px'
                }}>
                  <p style={{
                    color: 'rgba(255,255,255,0.95)', 
                    fontSize: '1.4rem', 
                    fontWeight: '400',
                    lineHeight: '1.8',
                    margin: 0,
                    textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                  }}>
                    Imagine yourself living in a cave, you need a stick to survive it is useful back there 
                    to kill a snack or for defense. Nowadays, <span style={{ color: '#feca57', fontWeight: '600' }}>Technology trends are this era stick</span> that is 
                    useful for you. Your smartphone and your social media accounts are not a threat for you 
                    unless you direct it in the <span style={{ color: '#4facfe', fontWeight: '600' }}>right way</span>.
                  </p>
                </div>

                {/* Vision Highlights */}
                <div style={{ 
                  display: 'flex', 
                  gap: '40px', 
                  marginTop: '60px',
                  flexWrap: 'wrap',
                  justifyContent: 'center'
                }}>
                  <div style={{ textAlign: 'center' }}>
                    <div style={{
                      fontSize: '3rem',
                      fontWeight: '800',
                      color: '#feca57',
                      textShadow: '0 2px 4px rgba(0,0,0,0.3)',
                      marginBottom: '10px'
                    }}>💡</div>
                    <div style={{ color: 'rgba(255,255,255,0.9)', fontSize: '1.1rem', fontWeight: '600' }}>Innovation</div>
                  </div>
                  <div style={{ textAlign: 'center' }}>
                    <div style={{
                      fontSize: '3rem',
                      fontWeight: '800',
                      color: '#ff6b6b',
                      textShadow: '0 2px 4px rgba(0,0,0,0.3)',
                      marginBottom: '10px'
                    }}>🌱</div>
                    <div style={{ color: 'rgba(255,255,255,0.9)', fontSize: '1.1rem', fontWeight: '600' }}>Sustainability</div>
                  </div>
                  <div style={{ textAlign: 'center' }}>
                    <div style={{
                      fontSize: '3rem',
                      fontWeight: '800',
                      color: '#4facfe',
                      textShadow: '0 2px 4px rgba(0,0,0,0.3)',
                      marginBottom: '10px'
                    }}>📈</div>
                    <div style={{ color: 'rgba(255,255,255,0.9)', fontSize: '1.1rem', fontWeight: '600' }}>Growth</div>
                  </div>
                  <div style={{ textAlign: 'center' }}>
                    <div style={{
                      fontSize: '3rem',
                      fontWeight: '800',
                      color: '#feca57',
                      textShadow: '0 2px 4px rgba(0,0,0,0.3)',
                      marginBottom: '10px'
                    }}>🎯</div>
                    <div style={{ color: 'rgba(255,255,255,0.9)', fontSize: '1.1rem', fontWeight: '600' }}>Excellence</div>
                  </div>
                </div>

                {/* Call to Action */}
                <div style={{
                  marginTop: '50px',
                  padding: '30px',
                  background: 'rgba(255,255,255,0.1)',
                  borderRadius: '20px',
                  border: '1px solid rgba(255,255,255,0.2)'
                }}>
                  <h4 style={{
                    color: 'white',
                    fontSize: '1.8rem',
                    fontWeight: '600',
                    marginBottom: '15px',
                    textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                  }}>
                    Ready to Shape the Future?
                  </h4>
                  <p style={{
                    color: 'rgba(255,255,255,0.9)',
                    fontSize: '1.2rem',
                    margin: 0,
                    textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                  }}>
                    Join us in revolutionizing the digital marketing landscape and creating a better tomorrow through innovative technology.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      {/* CSS Animations */}
      <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-25px) rotate(180deg); }
        }
        @keyframes bounce {
          0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
          40% { transform: translateY(-20px); }
          60% { transform: translateY(-10px); }
        }
        @keyframes pulse {
          0% { transform: scale(1); }
          50% { transform: scale(1.3); }
          100% { transform: scale(1); }
        }
      `}</style>
    </div>
  );
}

export default SectionDark2;